import { useAuth } from 'react-oidc-context'
import { useSearchParams } from 'react-router-dom'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams()
  const authParam = searchParams.get('auth')

  const { isLoading, isAuthenticated, signinRedirect } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen text-xl font-extralight">
        Loading...
      </div>
    )
  }

  if (authParam === 'v2') {
    return <>{children}</>
  }

  if (!isAuthenticated) {
    const fullPath = window.location.pathname + window.location.search
    signinRedirect({ state: { returnUrl: fullPath } }).catch(error => {
      console.error('Error during sign-in redirect:', error)
    })
    return <div>Redirecting to login...</div>
  }

  return <>{children}</>
}

export default ProtectedRoute
